const pubsub = require('../../utils/pubsub'),
	screenUtil = require('../../utils/screen'),
	DEFAULT_THRESHOLD = 300,
	DEFAULT_DELAY = 30000,
	REFRESH_MODES = {
		'VIEW': 'view',
		'TIME': 'time'
	};

let slotsToRefresh,
	waitForInView,
	waitForOutOfView,
	waitForFirstTimeInView,
	waitForActiveWindow,
	mainViewThreshold,
	mainRefreshDelay;

function init(settings) {
	const cfgViewThreshold = typeof settings.refreshThreshold === 'undefined' ? DEFAULT_THRESHOLD : settings.refreshThreshold,
		cfgRefreshDelay = typeof settings.refreshDelay === 'undefined' ? DEFAULT_DELAY : settings.refreshDelay;

	waitForInView = [];
	waitForOutOfView = [];
	waitForFirstTimeInView = [];
	waitForActiveWindow = [];
	slotsToRefresh = [];
	mainViewThreshold = parseInt(cfgViewThreshold, 10);
	mainRefreshDelay = parseInt(cfgRefreshDelay, 10);

	if (typeof mainViewThreshold !== 'number' || isNaN(mainViewThreshold)) {
		mainViewThreshold = DEFAULT_THRESHOLD;
	}

	if (typeof mainRefreshDelay !== 'number' || isNaN(mainRefreshDelay)) {
		mainRefreshDelay = DEFAULT_DELAY;
	}

	pubsub.subscribe('slot.rendered', _onSlotRendered);
	pubsub.subscribe('scroll', _onScroll);
	document.addEventListener('visibilitychange', _onVisibilityChanged);
}

function _getThreshold(slot) {
	const threshold = typeof slot.refreshThreshold === 'undefined' ? mainViewThreshold : parseInt(slot.refreshThreshold, 10);

	if (typeof threshold !== 'number' || isNaN(threshold)) {
		return mainViewThreshold;
	}

	return threshold;
}

function _getDelay(slot) {
	const delay = typeof slot.refreshDelay === 'undefined' ? mainRefreshDelay : parseInt(slot.refreshDelay, 10);

	if (typeof delay !== 'number' || isNaN(delay)) {
		return mainRefreshDelay;
	}

	return delay;
}

function _onSlotRendered(slot) {
	if (slot.refreshable) {
		if (screenUtil.isInView(slot.node, 0)) {
			_handleRefresh(slot);
		} else {
			waitForFirstTimeInView.push(slot);
		}
	}
}

function _handleRefresh(slot) {
	// It's already being refreshed
	if (slotsToRefresh.some((st) => st.slot === slot)) {
		return;
	}

	const slotState = {
		slot,
		'timer': null
	};

	if (_isViewModeRefresh(slot)) {
		waitForOutOfView.push(slot);
	}

	if (_isTimeModeRefresh(slot)) {
		slotState.timer = setTimeout(() => {
			_doRefresh(slot, REFRESH_MODES.TIME);
		}, _getDelay(slot));
	}

	slotsToRefresh.push(slotState);
}

function _doRefresh(slot, refreshMode) {
	const idx = slotsToRefresh.findIndex((st) => st.slot === slot);

	if (idx === -1) {
		return;
	}

	if (document.visibilityState !== 'visible') {
		waitForActiveWindow.push({
			slot,
			refreshMode
		});

		return;
	}

	clearTimeout(slotsToRefresh[idx].timer);
	slotsToRefresh[idx].slot.refresh(refreshMode);
	slotsToRefresh.splice(idx, 1);
}

function _isViewModeRefresh(slot) {
	return !slot.refreshModes || slot.refreshModes.indexOf(REFRESH_MODES.VIEW) !== -1;
}

function _isTimeModeRefresh(slot) {
	return slot.refreshModes && slot.refreshModes.indexOf(REFRESH_MODES.TIME) !== -1;
}

function _onScroll() {
	waitForOutOfView = waitForOutOfView.filter((slot) => {
		if (!screenUtil.isInView(slot.node, _getThreshold(slot))) {
			waitForInView.push(slot);

			return false;
		}

		return true;
	});

	waitForInView = waitForInView.filter((slot) => {
		if (screenUtil.isInView(slot.node, _getThreshold(slot))) {
			_doRefresh(slot, REFRESH_MODES.VIEW);

			return false;
		}

		return true;
	});

	waitForFirstTimeInView = waitForFirstTimeInView.filter((slot) => {
		if (screenUtil.isInView(slot.node, 0)) {
			_handleRefresh(slot);

			return false;
		}

		return true;
	});
}

function _onVisibilityChanged() {
	if (document.visibilityState === 'visible') {
		waitForActiveWindow.forEach(({slot, refreshMode}) => _doRefresh(slot, refreshMode));
	}
}

module.exports = {
	init,
	REFRESH_MODES
};
